import { render } from "./ChatRoomTool.vue?vue&type=template&id=3db2bd7e&scoped=true"
import script from "./ChatRoomTool.vue?vue&type=script&lang=js"
export * from "./ChatRoomTool.vue?vue&type=script&lang=js"

import "./ChatRoomTool.vue?vue&type=style&index=0&id=3db2bd7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db2bd7e"]])

export default __exports__